import Vue from 'vue'

import VueSweetAlert from 'vue-sweetalert'
import VModal from 'vue-js-modal'
import SimpleVueValidation from 'simple-vue-validator'
import PulseLoader from 'vue-spinner/src/PulseLoader'
import VueTheMask from 'vue-the-mask'
import { VueEditor } from 'vue2-editor'

import App from './App.vue'
import router from './router'
import NavBar from '@/components/NavBar'
import SideBar from '@/components/SideBar'
import Loading from '@/components/Loading'

import '@/assets/css/style.css'
import '@/assets/css/components.css'


Vue.config.productionTip = false

Vue.use(VueSweetAlert)
Vue.use(VModal)
Vue.use(SimpleVueValidation)
Vue.use(VueTheMask)
Vue.component('vue-editor', VueEditor)
Vue.component('NavBar', NavBar)
Vue.component('SideBar', SideBar)
Vue.component('Loading', Loading)
Vue.component('pulse-loader', PulseLoader)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js